module.exports = __webpack_public_path__ + "img/bg_main0202.8eac1ee6.png";